const routeError = [
  {
    path: '/chrome-only',
    name: 'ChromeOnly',
    meta: {
      layout: 'ErrorLayout',
    },
  },
  {
    path: '/timeout',
    name: 'TimeOut',
    meta: {
      layout: 'ErrorLayout',
    },
  },
  {
    path: '/invalidauth',
    name: 'InvalidAuth',
    meta: {
      layout: 'ErrorLayout',
    },
  },
  {
    path: '/unauthorised',
    name: 'Unauthorised',
    meta: {
      layout: 'UnauthorisedErrorLayout',
    },
  },
];

export default routeError;
